import React, { Component } from "react";
import MultiCarousal1 from "./multicarousals/multicarousal";
import AdvertisementCarousal from "./multicarousals/multicarousal";

class BannerTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baseurl: props.baseUrl,
      data: props.data,
      advUrl: props.advUrl,
      advdata: props.advdata || [],
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      baseurl: nextProps.baseUrl,
      data: nextProps.data,
      advUrl: nextProps.advUrl,
      advdata: nextProps.advdata || [],
    });
  }

  render() {
    const { baseurl, data, advUrl, advdata } = this.state;
    let lang = this.props.state.language;
    const imageUrl = data[lang]?.image;
    const isVideo = imageUrl?.match(/\.(mp4|mov|webm|mkv|avi)$/i);
    
    return (
      <div className="w-100">
        {data && (
          <div className="banner">
            <div>
              {isVideo ? (
                <video
                  src={imageUrl}
                  className="w-100 banner-img"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : (
                <img
                  src={imageUrl}
                  className="w-100 banner-img"
                  alt=""
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default BannerTile;
